import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import WIcon from '@/components/wrapper/w-icon.vue';
let SidePanel = class SidePanel extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "title", void 0);
  }
};
__decorate([Prop({
  default: false
})], SidePanel.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], SidePanel.prototype, "title", void 0);
SidePanel = __decorate([Options({
  components: {
    WIcon
  }
})], SidePanel);
export default SidePanel;